module.exports = __webpack_public_path__ + "media/images/mobile-view-1920-3a26f427dca42513e5f40962ff4ffa9c.svg";